import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PCConsultingLanding from "./pages/PCConsultingLanding";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PCConsultingLanding />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
